import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { Device } from '@capacitor/device';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class DeepLinkService {
  constructor(private http: HttpClient, private router: Router) {}

  async fingerprint(): Promise<string> {
    const info = await Device.getInfo();                       // @capacitor/device (already installed)
    return [info.platform, info.osVersion?.split('.')[0],
            Intl.DateTimeFormat().resolvedOptions().timeZone].join('|'); // signals stable web→native
  }

  // ponytail: dormant — endpoint 404s today; fail-safe catch means no visible effect until D1 is deployed.
  async resumeFromInstall(): Promise<void> {                   // call once on first cold launch, if no session
    try {
      const fp = await this.fingerprint();
      const p: any = await lastValueFrom(
        this.http.post<any>(`${environment.authUrl}/api/deeplink/match`, {},
          { headers: { 'X-Device-FP': fp } })
      );
      if (p?.code && p?.sta) {
        this.router.navigate(['/register'], { queryParams: { code: p.code, sta: p.sta } });
      }
    } catch { /* endpoint absent or no match → normal flow (fail-safe) */ }
  }
}
